import type React from 'react';

import cn from '../../../utils/cn';

export interface StatsIconProps {
  icon?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}

const StatsIcon = ({ icon, children, className }: StatsIconProps) => {
  return <div className={cn(className)}>{icon || children}</div>;
};

StatsIcon.displayName = 'Stats.Icon';

export default StatsIcon;
